<template lang="">
  <div>
    <el-input
      v-model="taskValue"
      :rows="30"
      type="textarea"
      placeholder="Please input"
      @input="onInput($event)"
    />
    <span style="font-size:14px; color:grey;">Words: {{ wordsCount }} / {{ wordsMax }}</span>
  </div>
</template>
<script>

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    task: {
      type: String,
      default: ''
    },
    taskType: {
      type: String,
      default: 'Task1'
    }
  },
  data() {
    return {
      taskValue: undefined,
      wordsCount: 0
    }
  },
  computed: {
    getValue() {
      return this.task
    },
    wordsMax() {
      return this.taskType === 'Task1' ? 150 : 250
    }
  },
  watch: {
    getValue: {
      deep: true, // 深度监听
      handler(newVal, oldVal) {
        this.taskValue = this.task
        this.wordsCount = this.getWordsCount(this.taskValue)
      }
    }
  },
  mounted() {
    this.taskValue = this.task
    this.wordsCount = this.getWordsCount(this.taskValue)
  },
  methods: {
    onInput(e) {
      var _length = this.getWordsCount(e)
      this.wordsCount = _length
      this.$emit('onInput', e)
    },
    getWordsCount(val) {
      if (val === null || val === '' || val === undefined || val === 'null' || val === 'undefined') {
        return 0
      }
      var value = val
      // 替换中文字符为空格
      value = value.replace(/[\u4e00-\u9fa5]+/g, ' ')
      // 将换行符，前后空格不计算为单词数
      value = value.replace(/\n|\r|^\s+|\s+$/gi, ' ')
      // 多个空格替换成一个空格
      value = value.replace(/\s+/gi, ' ')
      // 更新计数
      var length = 0
      var match = value.match(/\s/g)
      if (match) {
        length = match.length + 1
      } else if (value) {
        length = 1
      }
      return length
    }
  }

}
</script>
<style lang="scss" scoped>
.show-alert{
  margin-bottom: 8px;
}
</style>
